module.exports = __webpack_public_path__ + "img/wallet-add-1.6c89495a.svg";